<script setup lang="ts">
import { computed } from 'vue';

import KSelectField, {
  type FieldSize,
  type Item,
} from '@/components/fields/KSelectField.vue';
import {
  jobEditProductPrefixItems,
  jobEditProductPrefixShortTitles,
} from '@/constants/fieldItems';

export interface Props {
  modelValue?: string;
  disabled?: boolean;
  readonly?: boolean;
  label?: string;
  size?: FieldSize;
  rules?: ((v: string | number | boolean | null) => boolean | string)[];
}

const props = withDefaults(defineProps<Props>(), {
  modelValue: '-',
  disabled: false,
  readonly: false,
  label: 'Prefix',
  size: 'md',
  rules: () => [],
});

const emit = defineEmits<{
  'update:modelValue': [value: string | undefined];
}>();

const fieldValue = computed({
  get() {
    return props.modelValue;
  },
  set(value: string | undefined) {
    emit('update:modelValue', value);
  },
});

const PREFIX_OPTIONS: Item[] = jobEditProductPrefixItems;
</script>

<template>
  <div :class="$style.productPrefixSelect" data-testid="productPrefixSelect">
    <KSelectField
      v-model="fieldValue"
      :items="PREFIX_OPTIONS"
      :label="props.label"
      :disabled="props.disabled"
      :readonly="props.readonly"
      :size="props.size"
      :rules="props.rules"
      :clearable="false"
    >
      <template #selection="{ item }">
        {{ jobEditProductPrefixShortTitles[String(item.value)] ?? item.title }}
      </template>
    </KSelectField>
  </div>
</template>

<style module lang="scss">
.productPrefixSelect {
  display: contents;
}
</style>
